import type { Move } from '../../../schemas/move';
import { druidoArchetypeMoves } from './archetypes';
import { druidoInitialMoves, druidoStartingAutoMoves, druidoStartingChoiceMoves } from './initial';
import { druidoAdvanced2to5Moves } from './advanced-2-5';
import { druidoAdvanced6to10Moves } from './advanced-6-10';

export {
  druidoArchetypeMoves,
  druidoInitialMoves,
  druidoStartingAutoMoves,
  druidoStartingChoiceMoves,
  druidoAdvanced2to5Moves,
  druidoAdvanced6to10Moves,
};

/**
 * Catalogo completo delle mosse del Druido (manuale V1, sezione "Il
 * Druido", rr. 2962-3318).
 *
 * Aggregato di:
 *  - 5 archetipi (`class_special`)
 *  - 4 mosse iniziali automatiche + 2 mosse iniziali di scelta (`starting`,
 *    `pickCount: 1` sul gruppo di scelta — *Divinità della Natura* / *Mutaforma*)
 *  - 16 mosse avanzate L2-5 (`advanced_2_5`)
 *  - 14 mosse avanzate L6-10 (`advanced_6_10`)
 *
 * Totale: 41 mosse.
 *
 * **Pattern stress-testati per la prima volta in questa classe**:
 *  - **Casteggiante condizionato**: il PG è casteggiante solo se sceglie
 *    *Divinità della Natura* nel gruppo iniziale (alternativa: *Mutaforma*
 *    — niente casting). La mossa *Divinità della Natura* è il trigger del
 *    casting nel sistema `services/spellAccess.ts`.
 *  - **Mossa-config *Nato dalla Terra*** con 10 opzioni Terra strutturate
 *    (`MoveSchema.choices`, choiceCount 1) + Segno Rivelatore in description.
 *  - **`prerequisites.allOf`** su *Magia Fatata* e *Il Folletto*.
 *  - **Cross-class anyOf**: *Colui che Parla alle Cose* e *Spiriti
 *    Guardiani* con forward-reference a `sciamano.portavoce-dell-aldila`.
 */
export const druidoMoves: readonly Move[] = [
  ...druidoArchetypeMoves,
  ...druidoInitialMoves,
  ...druidoAdvanced2to5Moves,
  ...druidoAdvanced6to10Moves,
];
